<template>
  <div>
    <div>
      <div class="matrix-scale" v-for="(rowItem, id) of rowData.questionDetails.issue.items" :key="id">
        <h1 v-html="transformHtml(rowItem.content.richText || rowItem.content.text)" />
        <el-radio-group
          class="matrix-nps-scale"
          v-model="getMatrixScale(rowData, id).model"
          @input="updateNewData($event, rowData, id)"
        >
          <el-radio v-for="(item, id) of rowData.questionDetails.issue.labels" :key="id" :label="getNps(item, rowData)">{{
            item.text
          }}</el-radio>
        </el-radio-group>
      </div>
    </div>
  </div>
</template>

<script>
import { itemInitOptions } from '../config/config.js'
import { getNps, updateNewData, saveArr } from '../public/index.js'
import '../public/style.css'

export default {
  name: 'MatrixScale',
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 需要更新的 数组
    updateArr: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    getMatrixScale() {
      return function (row, id) {
        const item = row.items.length ? row.items[id] : null
        // 有值 编辑
        if (item) {
          return {
            model: item.value
          }
          // 无值 初始化
        } else {
          // 根据issue.items 初始化row.items
          const iItems = row.questionDetails.issue.items
          iItems.forEach(item => {
            row.items.push(
              Object.assign({}, itemInitOptions, {
                optionId: item.id
              })
            )
          })
          return {
            model: row.items[id].value
          }
        }
      }
    }
  },
  inject: ['transformHtml'],
  methods: {
    updateNewData,
    getNps,
    saveArr
  }
}
</script>

<style lang="scss" scoped></style>
